import { LoginWithCredentials } from 'module/authentication/components/login-with-credentials';
import { LoginWithToken } from 'module/authentication/components/login-with-token/login-with-token';
import { TokenError } from 'module/authentication/components/token-error';
import { useUserAuthenticationState } from 'module/authentication/state/auth-state';
import { TokenErrorStatus, TokenType } from 'module/authentication/types';
import { getTokenMeta } from 'module/authentication/utils/decode-token';
import { logout } from 'module/authentication/utils/logout';
import { useIsSamlMandatory } from 'module/authentication/utils/saml';
import { useQueryParams } from 'module/helpers/location-query-params';
import { PageLoading } from 'module/ui/components/atoms/loading';
import { Navigate, useNavigate } from '@rocketlane/rocket-router';
import { AccountAPI } from 'api/account';
import { ROCKETLANE_EMAILS, ROCKETLANE_LOGIN } from 'constant';
import { useAuthenticateLinks } from 'helpers/use-authenticate-links';
import { useAccountMetaQuery } from 'queries/account';
import { useCallback } from 'react';

// TODO: move this to page
export const Login = () => {
  const navigate = useNavigate();
  const authState = useUserAuthenticationState();
  const { data: accountMeta, isLoading: isMetaLoading } = useAccountMetaQuery();
  const params = useQueryParams();
  const token = params.get('token') ?? '';
  const cognitoType = params.get('cognito') ?? '';
  const extToken = params.get('rl-token') ?? '';
  const overrideAuth = params.get('overrideAuth') ?? false;
  const { isExpired, decoded } = getTokenMeta(token);
  const isSamlMandatory = useIsSamlMandatory({ accountMeta });
  const resendEmail = useCallback(() => {
    if (decoded) {
      AccountAPI.forgotAccount({ email: decoded.emailId });
    }
  }, [decoded]);
  const links = useAuthenticateLinks();

  if (decoded && isExpired) {
    return (
      <TokenError
        status={TokenErrorStatus.Expired}
        email={decoded.emailId}
        resendEmail={resendEmail}
        loginUrl={ROCKETLANE_LOGIN}
        supportEmail={ROCKETLANE_EMAILS.support}
      />
    );
  }

  if (overrideAuth) {
    logout(`?token=${token}`);

    return <PageLoading />;
  }

  return !authState || isMetaLoading || accountMeta == null ? (
    <PageLoading />
  ) : authState.isAuthenticated ? (
    <Navigate
      replace
      to={new URL(window.location.origin).href.replace(
        window.location.origin,
        '',
      )}
    />
  ) : token || extToken ? (
    <LoginWithToken
      token={token || extToken || ''}
      tokenType={
        extToken
          ? TokenType.External
          : cognitoType
            ? TokenType.Cognito
            : TokenType.Rocketlane
      }
      oktaData={accountMeta.okta}
      loginUrl={ROCKETLANE_LOGIN}
      supportEmail={ROCKETLANE_EMAILS.support}
      postLogin={() => navigate('/', { replace: true })}
      postOtpTrigger={() => {}}
    />
  ) : (
    <LoginWithCredentials
      oktaMetaData={accountMeta.okta}
      isSamlMandatory={isSamlMandatory}
      company={accountMeta.company}
      links={links}
    />
  );
};
